import React from 'react';
import PropTypes from 'prop-types';
import styles from './FilterCategory.module.css';

const FilterCategory = ({
  selectedCategory,
  setSelectedCategory,
  categories,
}) => {
  function onCategoryChangeHandler(event) {
    const name = event.target.value;
    const id = event.target.options[event.target.selectedIndex]?.id;

    setSelectedCategory({
      name,
      id,
    });
  }

  const TransformedCategories = [
    ...new Set(categories.map(({ category, id }) => ({ category, id }))),
  ];

  return (
    <select
      id={styles['filter-category']}
      onChange={onCategoryChangeHandler}
      value={selectedCategory.name}
    >
      <option value="none" selected>
        select a category
      </option>
      {TransformedCategories.map(({ category, id }) => (
        <option value={category} id={id}>
          {category}
        </option>
      ))}
    </select>
  );
};

FilterCategory.propTypes = {
  setSelectedCategory: PropTypes.node.isRequired,
  selectedCategory: PropTypes.node.isRequired,
  categories: PropTypes.node.isRequired,
};

export default FilterCategory;
